import * as Err from '@fixtuur/error-context';
import { Context, Effect, Layer } from 'effect';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { iso } from 'newtype-ts';
import { match } from 'ts-pattern';
import * as Api from '../../api/';
import { ConfigurationsService, GavelConfigurationsService } from '../../api/configuration';
import { getHeroParts } from '../../api/configuration/configuration';
import * as P from './particle';
const _ = iso();
export const construct = (c) => _.wrap({ ...c, tag: 'Configuration' });
export const particles = (c) => _.unwrap(c).particles;
export const heroParts = (c) => _.unwrap(c).heroParts;
export const particleIds = (c) => particles(c).map(P.id);
export const apiParticles = (c) => particleIds(c).map(Api.Configuration.Particle.construct);
export const particleMap = (c) => new Map(particles(c).map(p => [P.id(p), p]));
export var FromApiErrorMessage;
(function (FromApiErrorMessage) {
    FromApiErrorMessage["Fetch"] = "Error fetching particles from API";
})(FromApiErrorMessage || (FromApiErrorMessage = {}));
export const fromApi = (serviceConfig, c) => pipe(P.fromIds(serviceConfig, c.parts), TE.map(particles => construct({ particles, heroParts: getHeroParts(c) })), TE.mapLeft(e => match(e.message)
    .with(P.FromIdsErrorMessage.FetchAttachmentData, () => Err.swap(FromApiErrorMessage.Fetch)(e))
    .exhaustive()));
export class Fixtuur3dxConfigurations extends Context.Tag('@fixtuur/backpack/Fixtuur3dxConfigurations')() {
}
export const LiveFixtuur3dxConfigurations = Layer.effect(Fixtuur3dxConfigurations, Effect.gen(function* (_) {
    const configurationsService = yield* _(ConfigurationsService);
    /**
     *
     * get all config spaces for tenant,
     * return a list of all products appearing in those spaces.
     *
     */
    const productsInSpaces = tenant => Effect.gen(function* (_) {
        const allSpaces = yield* _(configurationsService.getSpaces(tenant)).pipe(Effect.map(res => res.spaces));
        const allOptions = yield* _(Effect.forEach(allSpaces, spaceId => configurationsService.getOptionsForSpace(spaceId, tenant), { concurrency: 20 }));
        const productIds = new Set();
        allOptions.forEach(options => {
            Object.entries(options.properties).forEach(([key, values]) => {
                if (key.includes(':Product')) {
                    values.forEach(value => {
                        if (value !== null && typeof value === 'string') {
                            productIds.add(value);
                        }
                    });
                }
            });
        });
        return Array.from(productIds);
    });
    return {
        productsInSpaces,
    };
})).pipe(Layer.provide(GavelConfigurationsService));
